// ABOUTME: Skeleton placeholder shaped like GameCard — shown while games are loading.
// ABOUTME: Mirrors the card layout (title, pack name, player count) to prevent layout shift.
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Skeleton from '@mui/material/Skeleton'
import Stack from '@mui/material/Stack'

export function GameCardSkeleton() {
  return (
    <Card data-testid="game-card-skeleton">
      <CardContent>
        <Stack spacing={1}>
          <Skeleton variant="text" width="60%" height={32} />
          <Skeleton variant="text" width="45%" />
          <Skeleton variant="text" width="30%" />
        </Stack>
      </CardContent>
    </Card>
  )
}
